import React, { useState } from "react";
import { Link } from "react-router-dom";
import MenuItem from "./MenuItem";

export default function MenuDropdown({
  subKey,
  subLinkTo,
  subName,
  map,
  itemLinkTo,
  subCat,
  side,
}) {
  const [showSubcategories, setShowSubcategories] = useState([]);
  const [showSubcategory, setShowSubcategory] = useState(-1);

  const toggleSubcategory = (subcategoryId) => {
    let updatedShowSubcategories = [...showSubcategories];
    const subcategoryIdx = updatedShowSubcategories.indexOf(subcategoryId);
    if (subcategoryIdx > -1) {
      updatedShowSubcategories.splice(subcategoryIdx, 1);
    } else {
      updatedShowSubcategories.push(subcategoryId);
    }
    setShowSubcategories(updatedShowSubcategories);
  };

  const toggleSingleSubcategory = (subcategoryId) => {
    setShowSubcategory(subcategoryId);
  };

  return (
    <li key={subKey} className="dropdown">
      <Link
        to={subLinkTo}
        // onMouseEnter={() => toggleSingleSubcategory(subCat.id)}
        // onMouseLeave={() => toggleSingleSubcategory(subCat.id)}
        className="hidden lg:inline-flex py-2 px-2 font-semibold whitespace-no-wrap hover:text-pink-350 transition-all"
      >
        {" "}
        {subName}
        {/* &#x23f7; */}
      </Link>
      {showSubcategory === subCat.id ? (
        <ul
          className={`dropdown-content lg:absolute lg:hidden bg-white pl-5 ${
            side === "left" ? "lg:-ml-60" : "lg:ml-48"
          } lg:-mt-10 w-60`}
        >
          {map
            .sort((a, b) => a.id - b.id)
            .map((item) => (
              <MenuItem
                key={`menu-dropdown-item-${item.id}`}
                linkTo={`${itemLinkTo}/${subCat.id}/${item.id}/${subCat?.itemId}`}
                name={item.name}
              />
            ))}
        </ul>
      ) : null}
      <button
        className="inline-flex lg:hidden py-2 px-2 font-semibold items-center uppercase"
        // onClick={() => toggleSubcategory(subCat.id)}
      >
        {subName} {showSubcategories.indexOf(subCat.id) > -1 ? <>&#x23f7;</> : <>&#x23f5;</>}
      </button>
      {showSubcategories.indexOf(subCat.id) > -1 ? (
        <ul className="dropdown-content lg:absolute lg:hidden bg-white pl-5 lg:ml-48 lg:-mt-10 w-60">
          {map
            .sort((a, b) => a.id - b.id)
            .map((item) => (
              <MenuItem
                key={`menu-dropdown-item-${item.id}`}
                linkTo={`${itemLinkTo}/${subCat.id}/${item.id}/${subCat?.itemId}`}
                name={item.name}
              />
            ))}
        </ul>
      ) : null}
    </li>
  );
}
